import Cookie from 'corp-front-vue-commons/src/utils/Cookie'
import store from '@/store'
import { apiInstance, loginPath } from '../index'
import { SESSION_USER, SESSION_HEADERS, SESSION_COMPANY, SESSION_EXPIRES_TIME } from 'utils/constants'

const session = {
  login (data) {
    return apiInstance({
      method: 'POST',
      url: `${loginPath()}/login`,
      data
    })
  },

  logout () {
    // remove cookies, localStorage or sessionStorage items
    Cookie.set(SESSION_USER, '', 0)
    localStorage.removeItem(SESSION_HEADERS)
    localStorage.removeItem(SESSION_COMPANY)
    localStorage.removeItem(SESSION_EXPIRES_TIME)

    // dispatch events
    store.dispatch('session/loginFailure')
    store.dispatch('claims/clear')
    store.dispatch('company/clearSelectedCompany')
  },

  forgotPassword (email) {
    return apiInstance({
      method: 'PUT',
      url: `${loginPath()}/forgotPassword`,
      data: `email=${email}`
    })
  },

  resetPassword (data) {
    return apiInstance({
      method: 'PUT',
      url: `${loginPath()}/changePassword`,
      data
    })
  }
}

export default session
